<template>
	<section class="wrap_pop">
		<div class="popbox_wrap">
			<div class="popbox_cont">
				<div class="box_msg type_kakao">
					<p>카카오톡 최신버전 확인</p>
				</div>
				<div class="box_info">
					<ul class="info_step">
						<li>카카오톡 최신버전에 최적화되어있습니다.</li>
						<li>하위버전은 서명에 제한이 있을 수 있습니다.</li>
					</ul>
				</div>
				<div class="info_wrap">
					<div class="tit">카카오톡 접속 시 버전 확인</div>
					<div class="cont">
						<ul class="info_next">
							<li>우측상단 <span class="point">톱니바퀴 &gt; 설정 &gt; 버전정보</span></li>
							<li>현재 화면에서는 확인이 불가능합니다.</li>
							<li>뒤로가기를 눌러 이전 화면에서 진행하시면 됩니다.</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="popbox_btn">
				<!-- <div><button type="button" class="btn color2">취소</button></div> -->
				<div><button type="button" class="btn color1" @click="$emit('close')">확인</button></div>
			</div>
		</div>
	</section>
</template>

